<template>
    <div v-if="scenes.deviceLinkageActions!=undefined && scenes.deviceLinkageConditions.length>0">
  <div class="main" v-if="scenes.deviceLinkageActions!=undefined && scenes.deviceLinkageActions.length>0" style="padding-left: 10px;">
      <div class="mr-3" type="primary" style="margin-top: 10px;">联动 </div>
      <ul class="mt-4">
          <li>
              <ul>
                  <li>
                      <ul>
                          <li>
                              {{scenes.deviceLinkageActions[0].isMatches+''=='true'?'':'不'}}匹配时执行：
                          </li>
                      </ul>
                      <ul  v-for="(item,index) in scenes.deviceLinkageActions" :key="index">
                          <li>动作：{{item.spaceName}} — {{item.deviceName}}
                              <span v-if="item.channel">  — 通道{{item.channel}} </span>
                              <span v-if="item.devicePointName.length>0">  — {{item.devicePointName}} — {{item.pointValue}}</span>
                              <span v-else>(联动设备)</span>
                          </li>
                      </ul>
                  </li>
                  <li>
                      <ul>
                        <li>
                            <el-link :underline="false"  @touchstart="showUpdDialog" @click="showUpdDialog" class="mr-3" icon="el-icon-edit-outline" type="primary">编辑</el-link>
                        </li>
                      </ul>
                  </li>
              </ul>
          </li>
      </ul>
  </div>
    <div  class="main" v-else>
        <div style="text-align: center;margin-top: 61px;" >
            <el-button @touchstart="showDialog" @click="showDialog"><i class="el-icon-circle-plus-outline"></i> 新增动作</el-button>
        </div>
    </div>
    </div>
</template>

<script>
export default {
  name: "LinkageDetail",
    props:["scenes"],
    data() {
        return {
            scene:'',
        }
    },
    watch: {
        scenes(newVal){
            this.scene=newVal;
        }
    },
    methods:{
        showDialog(){
            this.$emit("showDialog", '新增联动','Condition',true,'40vw',this.scenes);
        },
        showUpdDialog(){
            this.$emit("showDialog", '编辑联动','Condition',true,'40vw',this.scenes.deviceLinkageActions);
        }
    }
}
</script>

<style scoped>
.main {
  width: 100%;
    min-height: 162px;
  background: rgba(41, 155, 255, 0.1);
  border: 1px solid #299BFF;
  border-radius: 2px;
}

.btn.edit {
  margin-top: 20px;
  float: right;
}

ul {
  padding-left: 20px;
}

ul li {
  list-style: none;
}

</style>
